const Image = (props) => {
    return(
        <>
            <img src={props.src} alt={props.alt} title={props.title} width={props.width} height={props.height} hspace={props.hspace} vspace={props.vspace} border={props.border} onClick={props.onClick} className={props.className}/>
        </>
    );
}

export default Image;